const parseJwt = function (token) {
  const base64Url = token?.split(".")[1] || "";
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  try {
    return JSON.parse(jsonPayload);
  } catch (ex) {
    return ex;
  }
};

const isTokenExpired = function (token) {
  if (!token) return true;

  const decoded = parseJwt(token);
  if (!decoded || !decoded.exp) return true;

  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
};

const getTokenExpirationTime = function (token) {
  if (!token) return null;

  const decoded = parseJwt(token);
  return decoded?.exp ? new Date(decoded.exp * 1000) : null;
};

const getTimeUntilExpiration = function (token) {
  if (!token) return 0;

  const expirationTime = getTokenExpirationTime(token);
  if (!expirationTime) return 0;

  const currentTime = new Date();
  const timeUntilExpiration = expirationTime.getTime() - currentTime.getTime();

  return Math.max(0, timeUntilExpiration);
};

export default {
  parseJwt,
  isTokenExpired,
  getTokenExpirationTime,
  getTimeUntilExpiration,
};
